// src/utils/splashScreen.js
// Branded full-screen splash (the pulsing Grateful Sun) lives in index.html so it
// paints BEFORE Vue/CSS load — covering the cold-start blank. The same element is
// reused as a "resuming…" cover when the installed PWA wakes from iOS suspension
// (Firestore reconnect can freeze the UI for several seconds). Plain DOM, no Vue,
// so it can show during those windows.

const SPLASH_ID = 'app-splash'
const RESUME_AFTER_MS = 3500 // ignore quick app-switches
const MIN_SHOW_MS = 500 // minimum visible time once shown
const MAX_SHOW_MS = 8000 // hard cap — always hide by here

function el() {
  return document.getElementById(SPLASH_ID)
}

export function hideInitialSplash() {
  const s = el()
  if (!s) return
  s.style.opacity = '0'
  s.style.pointerEvents = 'none'
  setTimeout(() => {
    s.style.display = 'none'
  }, 350)
}

function showSplash() {
  const s = el()
  if (!s) return
  s.style.display = 'flex'
  void s.offsetHeight // reflow so the opacity transition runs
  s.style.opacity = '1'
  s.style.pointerEvents = 'auto'
}

// Hide once the main thread has rendered a few frames on time (the freeze is over).
function hideWhenResponsive() {
  const start = Date.now()
  let last = performance.now()
  let smooth = 0
  function tick() {
    const now = performance.now()
    const dt = now - last
    last = now
    if (dt < 60) smooth += 1
    else smooth = 0
    const elapsed = Date.now() - start
    if ((smooth >= 5 && elapsed > MIN_SHOW_MS) || elapsed > MAX_SHOW_MS) {
      hideInitialSplash()
      return
    }
    requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}

export function initResumeOverlay() {
  // Only phones / the installed PWA get the suspend-resume freeze; skip desktop
  // so tab-switching doesn't flash the splash.
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || ''
  let standalone = false
  try {
    standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
  } catch {
    /* ignore */
  }
  const mobile = /iphone|ipad|ipod|android/i.test(ua)
  if (!standalone && !mobile) return

  let hiddenAt = 0
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now()
    } else if (document.visibilityState === 'visible') {
      if (hiddenAt && Date.now() - hiddenAt > RESUME_AFTER_MS) {
        showSplash()
        hideWhenResponsive()
      }
      hiddenAt = 0
    }
  })
}
